import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=ca8753a0"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=ca8753a0&prod&lang=css"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=ca8753a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports